import * as translator from "../../../../utils/translator";

interface Props {
  language: string;
  /** Formatted plan bonus. */
  savingsLabel: string | null;
  onClick: (e: React.MouseEvent) => void;
}

// Arm B CTA (Figma 38938:513). `!` lifts the My Account button size caps; 13/11px fits desktop width.
// Inline so the gradient, clip and transparent fill always apply together.
const GRADIENT_LABEL_STYLE: React.CSSProperties = {
  backgroundImage: "linear-gradient(to right, #15967c, #72b33e)",
  WebkitBackgroundClip: "text",
  backgroundClip: "text",
  WebkitTextFillColor: "transparent",
  color: "transparent",
  textDecorationColor: "#15967c",
};

const SwitchToSubscriptionButton = ({ language, savingsLabel, onClick }: Props) => {
  // English when the language has no copy yet (.replace below must never get null).
  const text = (key: string): string =>
    translator.translate(language, "my_account", `MyOrders/${key}`) ?? translator.translate("en", "my_account", `MyOrders/${key}`) ?? "";

  return (
    <button
      type="button"
      id="account-order-card-switch-to-subscription"
      onClick={onClick}
      className="flex w-full !h-auto !max-h-none !max-w-none cursor-pointer flex-col items-center justify-center gap-[3px] rounded-[12px] border border-solid border-[#61a333] bg-white py-[11px]"
    >
      <span className="flex items-center justify-center rounded-[6px] px-[4px] py-[2px]">
        <span className="whitespace-nowrap text-center font-poppins text-[13px] font-semibold max-[1200px]:text-[14px] leading-[19.5px] underline" style={GRADIENT_LABEL_STYLE}>
          {text("switch_to_subscription")}
        </span>
      </span>
      <span className="flex items-start justify-center gap-[3px] whitespace-nowrap px-[4px] font-roboto text-[11px] leading-[16.5px] max-[1200px]:text-[12px] tracking-[0.11px] text-[#15967c]">
        {savingsLabel && (
          <span>
            <span className="font-medium">{text("switch_to_subscription_save").replace("::amount", savingsLabel)}</span> -
          </span>
        )}
        <span>{text("switch_to_subscription_cancel")}</span>
      </span>
    </button>
  );
};

export default SwitchToSubscriptionButton;
